module.exports = __webpack_public_path__ + "static/media/Cant Help It.abb0063c.jpg";